import Icon from '../components/Icon.vue'

Icon.register({
  ethernet: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 192H448V144C448 135.2 440.8 128 432 128H384V80C384 71.2 376.8 64 368 64H144C135.2 64 128 71.2 128 80V128H80C71.2 128 64 135.2 64 144V192H16C7.2 192 0 199.2 0 208V432C0 440.8 7.2 448 16 448H96V320H128V448H192V320H224V448H288V320H320V448H384V320H416V448H496C504.8 448 512 440.8 512 432V208C512 199.2 504.8 192 496 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ethernet.js
// module id = fYlf
// module chunks = 144